<script setup>
  import { ref, computed } from 'vue';

  import { useUserStore } from '@/stores/UserStore';
  import { useSpotStore } from '@/stores/SpotStore';

  import Icon from "@/components/icons/Icon.vue";
  
  const savedContainerName = defineModel('savedContainerName');

  const props = defineProps({
    containerTypeId: {
      type: String,
      required: false
    },  
    containerTypeName: {
      type: String,
      required: false
    },  
    settings: {
      type: Object,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    }
  });

  const spotStore = useSpotStore();
  const userStore = useUserStore();

  const autoSavedsectionId = ref(null);

  const saveToProfileHeader = computed(() => `Save ${spotStore.spotName} to Profile.`);
  const saveToProfileInstructions = computed(() => `Choose the profile${userStore.userProfiles.profiles.length > 1 ? 's' : ''} you would like to save <strong>${savedContainerName.value}</strong> to.`);

  const autoCheckProfile = computed(() => {
    return (profileId) => {

      if (!autoSavedsectionId.value) return false;

      const isFavoritedContainer = spotStore.isContainerFavoritedInProfile(profileId, autoSavedsectionId.value)

      return !isFavoritedContainer ? false : true;
    }
  });

  async function handleContainerProfileSelection(event) {
    if (event.target.checked) {
      const data = await userStore.addContainerToProfile(event.target.value, props.containerTypeId, savedContainerName.value, props.settings);
      
      if (data.status_code === 0) {
        event.target.setAttribute('data-container-id', data.status_message);
      }
    } else {
      const containerId = event.target.dataset.containerId;
      await userStore.removeContainerFromProfile(containerId);

      event.target.removeAttribute('data-container-id');
    }

    await userStore.getProfiles(true);
    userStore.refreshCurrentProfile();
  }  
</script>

<template>
  <header class="jwx-modal__header">
    <h2 class="jwx-modal__title">{{ saveToProfileHeader }}</h2>
  </header>          
  <div class="jwx-modal__body">
    <div class="jwx-modal__section">
      <p v-html="saveToProfileInstructions" class="jwx-modal__text"></p>
    </div>
    <div class="jwx-modal__section">
      <ul class="jwx-save-to-selector">
        <li v-for="profile in userStore.userProfiles.profiles" class="jwx-save-to-selector__item" :key="profile.profile_id">
          <input
            v-if="userStore.userProfiles.profiles.length > 1"
            @change="handleContainerProfileSelection"
            type="checkbox"
            :name="`jwx-${profile.profile_id}`"
            :id="`jwx-${profile.profile_id}`"
            :value="profile.profile_id"
            class="jwx-save-to-selector__input jwx-hidden-control"
          />
          <input
            v-if="userStore.userProfiles.profiles.length === 1"
            @change="handleContainerProfileSelection"
            type="checkbox"
            :name="`jwx-${profile.profile_id}`"
            :id="`jwx-${profile.profile_id}`"
            :value="profile.profile_id"
            :checked="autoCheckProfile(profile.profile_id)"
            :data-container-id="autoSavedsectionId"
            class="jwx-save-to-selector__input jwx-hidden-control"
          />
          <label :for="`jwx-${profile.profile_id}`" class="jwx-save-to-selector__label">
            <h4 class="jwx-save-to-selector__label-title">
              {{ profile.name }}
            </h4>
            <div class="jwx-save-to-selector__selection-indicator">
              <Icon name="checkmark" class="jwx-save-to-selector__indicator-icon" />
            </div>
          </label>
        </li>
      </ul>
    </div>
  </div>
  <div class="jwx-modal__footer">
    <div class="jwx-modal__actions">
      <button 
        type="button" 
        @click.prevent="closeModal"
        class="jwx-button jwx-button--success"
      >
        Done
      </button>
    </div>
  </div>
</template>